// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class HoursByLevel {
  levelId: string;
  levelDescription: string;
  difficulty: string;
  typicalOfCount: string;
  hardwarePoints: string;
  fln: string;
  softwarePoints: string;
  totalPoints: string;
  pm: number;
  eng: number;
  grap: number;
  prog: number;
  spec: number;
  dds: number;
  mech: number;
  elec: number;
  neng: number;
  qeng: number;
  ceng: number;
  eeng: number;
  leng: number;
  totalHours: number;
  totalCost: number;
  notes: string;
}
